import React, { useEffect, useState } from "react";

export const Prediction = ({ sign }) => {
  const [prediction, setPrediction] = useState([]);
  const [horoscopesign, setHoroscopeSign] = useState("");
  const [horDate, setHorDate] = useState(null);
  const [loading, setLoading] = useState(true);

  const options = {
    method: "POST",
    headers: {
      "X-RapidAPI-Key": "0afebb7776msh592551225328f26p17d954jsn8f8558987190",
      "X-RapidAPI-Host": "sameer-kumar-aztro-v1.p.rapidapi.com",
    },
  };

  const getHoroscope = (yoursign) => {
    return fetch(
      `https://sameer-kumar-aztro-v1.p.rapidapi.com/?sign=${yoursign}&day=today`,
      options
    )
      .then((response) => response.json())
      .then(({ description, current_date}) => {
        setPrediction(description);
        setHoroscopeSign(yoursign);
        setHorDate(current_date)
        setLoading(false);
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    getHoroscope(sign);
  }, [sign]);

  return (
    <div className="predContainer">
      {loading ? (
        <h3>Loading...</h3>
      ) : (
        <div>
          <div class="signImg">
            <h2>{horoscopesign} ({horDate})</h2>
            <img
              src={`./images/signs/${horoscopesign}.png`}
              alt={horoscopesign}
            />
          </div>
          <div className="predTxt">{prediction}</div>
        </div>
      )}
    </div>
  );
};
